// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TkXz","newExpiryDate":"styles_newExpiryDate__2FN90","footer":"styles_footer__2a8BZ"};